import { LoaderData } from "src/types";
import * as APITypes from "src/API";
import { API } from "aws-amplify";
import { getOffer } from "src/graphql/queries";

export const EMPTY_OFFER_INFO: APITypes.Offer = {
  id: "",
  startDate: "",
  endDate: "",
  createdAt: "",
  updatedAt: "",
  rent: 0,
  __typename: "Offer",
  status: APITypes.OfferStatusType.Pending,
  _version: 0,
  _lastChangedAt: 0,
};

export const getOfferInfo = async (
  id: string
): Promise<LoaderData<APITypes.Offer>> => {
  try {
    const response = (await API.graphql({
      query: getOffer,
      variables: {
        id: id,
      },
    })) as { data?: APITypes.GetOfferQuery };

    return {
      success: true,
      data: response.data?.getOffer || EMPTY_OFFER_INFO,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_OFFER_INFO,
      error,
    };
  }
};
